module.exports = __webpack_public_path__ + "static/media/stub-house.2950b2aa.svg";